import { HeroSection } from "../components/HeroSection";
import { FeaturesGrid } from "../components/FeaturesGrid";
import { TripBuilderShowcase } from "../components/TripBuilderShowcase";
import { ItineraryFormats } from "../components/ItineraryFormats";
import { ItineraryShowcase } from "../components/ItineraryShowcase";
import { CTABlock } from "../components/CTABlock";

export function HomePage() {
	return (
		<>
			<HeroSection />
			<FeaturesGrid />
			<TripBuilderShowcase />
			<ItineraryFormats />
			<ItineraryShowcase />
			<CTABlock />
		</>
	);
}
